import { FormType } from '../../../form-types';
import { WeightLossCVQuestionFieldAnswers } from './questions';

export const weightLossCv: FormType<WeightLossCVQuestionFieldAnswers> = {
  name: 'Weight Loss CV',
  questions: [
    'weightLossCv_intro',
    'generic_heightWeight2025',
    'weightLossCv_bloodPressure',
    'weightLossCv_restingHeartRate',
    'weightLossCv_cvdRiskFactors',
    'weightLossCv_familyEarlyCvd',
    'weightLossCv_suddenDeathFamily',
    'weightLossCv_tobaccoUse',
    'weightLossCv_activityDays',
    'weightLossCv_activityDuration',
    'weightLossCv_activityIntensity',
    'weightLossCv_processedFoods',
    'weightLossCv_alcohol',
    {
      key: 'weightLossCv_medicalConditions',
      next: {
        switch: [
          {
            condition: {
              'weightLossCv_medicalConditions.asymptomaticGallstones': true
            },
            key: 'weightLossCv_gallstonesConsent'
          },
          {
            condition: {
              'weightLossCv_medicalConditions.cholecystectomy': true
            },
            key: 'weightLossCv_cholecystectomyConsent'
          },
          {
            condition: {
              'weightLossCv_medicalConditions.thyroidIssues': true
            },
            key: 'weightLossCv_medicalConditionsDetail'
          }
        ],
        els: 'weightLossCv_glpAllergy'
      }
    },
    {
      key: 'weightLossCv_gallstonesConsent',
      next: {
        switch: [
          {
            condition: { 'weightLossCv_gallstonesConsent.non_consent': true },
            key: 'generic_didNotConsent'
          },
          {
            condition: {
              'weightLossCv_gallstonesConsent.consent': true,
              'weightLossCv_medicalConditions.cholecystectomy': true
            },
            key: 'weightLossCv_cholecystectomyConsent'
          }
        ],
        els: 'weightLossCv_medicalConditionsDetail'
      }
    },
    {
      key: 'weightLossCv_cholecystectomyConsent',
      next: {
        condition: { 'weightLossCv_cholecystectomyConsent.consent': true },
        key: 'weightLossCv_medicalConditionsDetail',
        els: 'generic_didNotConsent'
      }
    },
    'weightLossCv_medicalConditionsDetail',
    {
      key: 'weightLossCv_glpAllergy',
      next: {
        condition: { 'weightLossCv_glpAllergy.yes': true },
        key: 'generic_ineligible',
        els: 'weightLossCv_statinUse'
      }
    },
    {
      key: 'weightLossCv_statinUse',
      next: {
        switch: [
          {
            condition: { 'weightLossCv_statinUse.stoppedOneMuscle': true },
            key: 'weightLossCv_statinDetails'
          },
          {
            condition: { 'weightLossCv_statinUse.stoppedMultipleMuscle': true },
            key: 'weightLossCv_statinDetails'
          },
          {
            condition: { 'weightLossCv_statinUse.stoppedLiver': true },
            key: 'weightLossCv_statinDetails'
          },
          {
            condition: { 'weightLossCv_statinUse.stoppedOther': true },
            key: 'weightLossCv_statinDetails'
          }
        ],
        els: 'weightLossCv_hypoglycemiaMeds'
      }
    },
    'weightLossCv_statinDetails',
    {
      key: 'weightLossCv_hypoglycemiaMeds',
      next: {
        condition: { 'weightLossCv_hypoglycemiaMeds.yes': true },
        key: 'generic_ineligible',
        els: 'weightLossCv_interactingMeds'
      }
    },
    'weightLossCv_interactingMeds',
    {
      key: 'weightLossCv_recentWeightLossMeds',
      next: {
        condition: { 'weightLossCv_recentWeightLossMeds.none': true },
        key: 'weightLossCv_sexAssignedAtBirth',
        els: 'weightLossCv_lastTookMedication'
      }
    },
    {
      key: 'weightLossCv_lastTookMedication',
      next: {
        condition: { 'weightLossCv_lastTookMedication.past2to4Weeks': true },
        key: 'weightLossCv_restartLowerDose',
        els: 'weightLossCv_lastInjectionDate'
      }
    },
    'weightLossCv_restartLowerDose',
    'weightLossCv_lastInjectionDate',
    {
      key: 'weightLossCv_currentDose',
      next: {
        switch: [
          {
            condition: { 'weightLossCv_currentDose.dontSeeDose': true },
            key: 'weightLossCv_unlistedDose'
          },
          {
            condition: { 'weightLossCv_currentDose.dontKnowDose': true },
            key: 'weightLossCv_brandOrCompounded'
          }
        ],
        els: 'weightLossCv_sideEffects'
      }
    },
    {
      key: 'weightLossCv_unlistedDose',
      next: {
        condition: { 'weightLossCv_currentDose.dontSeeDose': true },
        key: 'weightLossCv_sideEffects',
        els: 'weightLossCv_sideEffects'
      }
    },
    'weightLossCv_brandOrCompounded',
    {
      key: 'weightLossCv_shareDoseMethod',
      next: {
        condition: { 'weightLossCv_shareDoseMethod.typeOut': true },
        key: 'weightLossCv_labelText',
        els: 'weightLossCv_labelPhoto'
      }
    },
    {
      key: 'weightLossCv_labelText',
      next: {
        condition: { 'weightLossCv_shareDoseMethod.typeOut': true },
        key: 'weightLossCv_sideEffects',
        els: 'weightLossCv_sideEffects'
      }
    },
    'weightLossCv_labelPhoto',
    {
      key: 'weightLossCv_sideEffects',
      next: {
        condition: { 'weightLossCv_sideEffects.yes': true },
        key: 'weightLossCv_sideEffectsDetail',
        els: 'weightLossCv_continueTreatment'
      }
    },
    'weightLossCv_sideEffectsDetail',
    'weightLossCv_continueTreatment',
    {
      key: 'weightLossCv_sexAssignedAtBirth',
      next: {
        condition: { 'weightLossCv_sexAssignedAtBirth.female': true },
        key: 'weightLossCv_pregnancy',
        els: 'weightLossCv_otherInfo'
      }
    },
    {
      key: 'weightLossCv_pregnancy',
      next: {
        condition: { 'weightLossCv_pregnancy.yes': true },
        key: 'generic_ineligible',
        els: 'weightLossCv_otherInfo'
      }
    },
    'weightLossCv_otherInfo',
    {
      key: 'weightLossCv_treatmentConsent',
      next: {
        condition: { 'weightLossCv_treatmentConsent.non_consent': true },
        key: 'generic_didNotConsent',
        els: 'generic_complete'
      }
    },
    'generic_complete',
    'generic_ineligible',
    'generic_didNotConsent'
  ]
};
